export default function NoAccess() {

  return (
    <div className="mt-3 w-full bg-white rounded-sm border-b-2 p-6 text-sm">
      Unfortunately you cannot access this feature!
    </div>
  );
}